var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAutoCharges(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14717_7158)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    transform: "translate(0 0.5)",
    fill: "white",
    fillOpacity: 0.01
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14717_7158)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9286 2.94655H12.5536V1.66084C12.5536 1.57244 12.4813 1.50012 12.3929 1.50012H11.2679C11.1795 1.50012 11.1071 1.57244 11.1071 1.66084V2.94655H5.96429V1.66084C5.96429 1.57244 5.89196 1.50012 5.80357 1.50012H4.67857C4.59018 1.50012 4.51786 1.57244 4.51786 1.66084V2.94655H1.14286C0.787277 2.94655 0.5 3.23383 0.5 3.58941V16.9287C0.5 17.2843 0.787277 17.5716 1.14286 17.5716H8.8854C8.96824 17.5716 9.0354 17.5044 9.0354 17.4216V16.2751C9.0354 16.1923 8.96824 16.1251 8.8854 16.1251H1.94643V8.49119H15.125V9.38339C15.125 9.46623 15.1922 9.53339 15.275 9.53339H16.4214C16.5043 9.53339 16.5714 9.46623 16.5714 9.38339V3.58941C16.5714 3.23383 16.2842 2.94655 15.9286 2.94655ZM1.94643 7.12512V4.39298H4.51786V5.35727C4.51786 5.44566 4.59018 5.51798 4.67857 5.51798H5.80357C5.89196 5.51798 5.96429 5.44566 5.96429 5.35727V4.39298H11.1071V5.35727C11.1071 5.44566 11.1795 5.51798 11.2679 5.51798H12.3929C12.4813 5.51798 12.5536 5.44566 12.5536 5.35727V4.39298H15.125V7.12512H1.94643Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5044 14.0334C17.5044 16.2425 15.7135 18.0334 13.5044 18.0334C11.8912 18.0334 10.5011 17.0784 9.86847 15.7029C9.82426 15.6067 9.89653 15.5001 10.0023 15.5001H11.0951C11.1465 15.5001 11.1942 15.5267 11.2229 15.5693C11.717 16.3017 12.5545 16.7834 13.5044 16.7834C15.0232 16.7834 16.2544 15.5522 16.2544 14.0334C16.2544 12.5146 15.0232 11.2834 13.5044 11.2834C12.722 11.2834 12.0161 11.61 11.5153 12.1344L12.5101 13.021C12.6061 13.0959 12.5775 13.2479 12.4609 13.2829L9.35037 13.916C9.25128 13.9457 9.15257 13.8686 9.15743 13.7652L9.26114 10.5642C9.26687 10.4427 9.4074 10.3782 9.50332 10.4531L10.527 11.3622C11.2593 10.5465 12.3219 10.0334 13.5044 10.0334C15.7135 10.0334 17.5044 11.8242 17.5044 14.0334Z",
    fill: "black",
    fillOpacity: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14717_7158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14717_7158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoCharges);
export default __webpack_public_path__ + "static/media/AutoCharges.e40d02607c41ccbd36a4470d6469ef70.svg";
export { ForwardRef as ReactComponent };